import Route from '@ember/routing/route';
import { ajax } from 'discourse/lib/ajax';

export default class AdminPluginsProxyviewsAnalyticsRoute extends Route {
  async model() {
    const overview = await ajax('/admin/plugins/proxyviews-analytics/overview');
    return { overview };
  }

  setupController(controller, model) {
    super.setupController(controller, model);
    // Write through reportData so the getter picks it up — assigning
    // directly to controller.overview throws "has only a getter".
    controller.reportData = { ...controller.reportData, overview: model.overview || {} };
    controller.loadedTabs = { ...controller.loadedTabs, overview: true };
  }
}
